import { Reducer } from 'redux'
import { fromJS } from 'immutable'
import { IVolunteers } from './../models'
import * as TYPES from './../actionTypes'

export const initialState: IVolunteers = fromJS({
  loading: false,
  types: [],
  volunteers: [],
})

const volunteersReducer: Reducer<IVolunteers> = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.SET:
      return state.merge(action.payload)
    case TYPES.CONTENT.TRIGGER:
      return state.set('loading', true)
    case TYPES.CONTENT.FULFILL:
      return state.set('loading', false)
    case TYPES.CONTENT.FAILURE:
      return state.set('error', action.payload)
    case TYPES.CONTENT.SUCCESS:
      return state.merge(action.payload)
    case TYPES.POST.REQUEST:
      return state.set('create_loading', true)
    case TYPES.POST.FULFILL:
      return state.set('create_loading', false)
    case TYPES.POST.SUCCESS:
      return state.set('create_success', true)
    default:
      return state
  }
}

export default volunteersReducer
